import { createPutEndpoint } from '@sonar-software/sonar-http';
import { SonarObjectUser } from '@types';

export type PutSonarObjectUsersRequest = {
	sonarObjectId: number;
	users: Array<SonarObjectUser>;
};

export const putSonarObjectUsers = createPutEndpoint<PutSonarObjectUsersRequest>(
	({ sonarObjectId }) => `/api/v3/core/sonar-objects/${sonarObjectId}/users`
);
